import { render, staticRenderFns } from "./SubAssuntoPesquisa.vue?vue&type=template&id=65fefdf7&"
import script from "./SubAssuntoPesquisa.vue?vue&type=script&lang=js&"
export * from "./SubAssuntoPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubAssuntoPesquisa.vue"
export default component.exports